import { I18nConfig } from '@spartacus/core';

export const defaultI18nConfig: I18nConfig = {
  i18n: {
    fallbackLang: undefined,
    debug: false,
  },
};
